import React from 'react';
import { Container, Typography, Box, Button } from '@mui/material';
import { useNavigate } from 'react-router-dom';
import { useTranslation } from 'react-i18next';

const CommunityRules: React.FC = () => {
  const navigate = useNavigate();
  const { t } = useTranslation();

  return (
    <Box sx={{ minHeight: '100vh' }}>
      <Container maxWidth="md" sx={{ py: 8 }}>
        <Button onClick={() => navigate('/blog')} sx={{ mb: 3, textTransform: 'none' }}>
          {t('blog.backToBlog')}
        </Button>
        <Typography variant="overline" color="primary" sx={{ fontWeight: 600 }}>
          Community · April 2026
        </Typography>
        <Typography variant="h3" component="h1" sx={{ my: 2, fontWeight: 700 }}>
          Community Rules — Building a Positive Platform
        </Typography>
        <Typography variant="body1" color="text.secondary" sx={{ mb: 4, lineHeight: 1.85 }}>
          Our community guidelines for viewers and creators to ensure IndeeClips remains a safe and positive space for
          everyone.
        </Typography>

        <Typography variant="h5" sx={{ mt: 5, mb: 2, fontWeight: 700 }}>
          Core Rules
        </Typography>
        <Box component="ul" sx={{ '& li': { mb: 2, color: 'text.secondary', lineHeight: 1.85 } }}>
          <li>
            <strong>Be Respectful:</strong> Treat all users with respect regardless of their background, beliefs or
            identity.
          </li>
          <li>
            <strong>No Hate Speech:</strong> Content or comments promoting hate against any group or individual are
            strictly prohibited.
          </li>
          <li>
            <strong>Protect Privacy:</strong> Do not share personal information of others without their consent.
          </li>
          <li>
            <strong>No Spam:</strong> Avoid repetitive comments, unsolicited links or promotional spam.
          </li>
          <li>
            <strong>Constructive Comments:</strong> Criticism is okay, but keep it constructive and respectful.
          </li>
          <li>
            <strong>Report Violations:</strong> Help us maintain a safe platform by reporting content that violates
            these rules.
          </li>
        </Box>

        <Typography variant="h5" sx={{ mt: 5, mb: 2, fontWeight: 700 }}>
          Consequences for Violations
        </Typography>
        <Typography variant="body1" color="text.secondary" sx={{ mb: 2, lineHeight: 1.85 }}>
          First violation: Warning and content removal. Second violation: Temporary account suspension (7-30 days).
          Third violation: Permanent account ban.
        </Typography>
        <Typography variant="body1" color="text.secondary" sx={{ mb: 3, lineHeight: 1.85 }}>
          Severe violations (hate speech, illegal content, harassment) may result in immediate permanent ban without
          prior warning.
        </Typography>

        <Typography variant="body1" color="text.secondary" sx={{ mt: 4, lineHeight: 1.85 }}>
          Report violations:{' '}
          <Typography
            component="a"
            href="mailto:contact@indeeclips.com"
            sx={{ color: 'primary.main', textDecoration: 'none', '&:hover': { textDecoration: 'underline' } }}
          >
            contact@indeeclips.com
          </Typography>
        </Typography>
      </Container>
    </Box>
  );
};

export default CommunityRules;
